<template>
  <li class="column is-6">
    <router-link class="column" :to="{ name: 'Page', params: { pageId: page.redirectId, rubricId : rubric.redirectId }}">
      <span>{{ page | hide }}</span>
      {{page.abstract}}
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'PageTile',
  props: {
    page: {
      required: true,
      type: Object
    },
    rubric: {
      required: true,
      type: Object
    }
  }
}
</script>
